export default [
  {
    name: 'setting-wa',
    path: '/settings/wa',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Parâmetros do WhatsApp',
      icon: 'dvr',
      label: 'Configurações gerais',
      roles: ['Admin']
    }
  }
]
